import { BaseParameterDto } from '../../../../../_models/base-parameter-dto';

export class DepositParametersDto extends BaseParameterDto {
    cmDepositId: number;
    managementCompanyId: number;
    communityId: number;

    getQueryString(): string {
        let url = `?clearCache=${this.clearCache}`;
        if (!!this.cmDepositId) {
            url = `${url}&cmDepositId=${this.cmDepositId}`;
        }

        if (!!this.managementCompanyId) {
            url = `${url}&managementCompanyId=${this.managementCompanyId}`;
        }

        if (!!this.communityId) {
            url = `${url}&communityId=${this.communityId}`;
        }
        return url;
    }
}
